import { SmartADVItem } from '@/shared/models';

const isThisPlacementEnabled = (
  item: SmartADVItem,
  expectedVariation: string | null
): boolean => {
  if (expectedVariation) {
    return item.experimentOnly === expectedVariation;
  }

  return !item.experimentOnly;
};

export { isThisPlacementEnabled };
